// Package authz.c3 establishes the foundation for permission and access
// control systems by defining what resources exist and what actions can be
// performed on them.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file authz/v3/authz.proto (package authz.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { UserAttribution } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file authz/v3/authz.proto.
 */
export const file_authz_v3_authz: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common]);

/**
 * Permission is a representation of a specific access control rule
 * that defines what actions can be performed on a resource.
 * Permissions define the "who can do what on which resources" relationship
 * and can be assigned to users or roles within the system.
 *
 * Example JSON representations:
 *
 * Basic permission allowing a user to read projects within an organization:
 * {
 *   "id": "permission_a1b2c3d4e5f6g7h8i9j0",
 *   "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_PROJECT",
 *   "accessType": "ACCESS_TYPE_READ",
 *   "realmType": "REALM_TYPE_ORGANIZATION",
 *   "created": {
 *     "userId": "user_1234567890abcdef1234",
 *     "timestamp": "2025-04-20T14:30:45Z"
 *   },
 *   "modified": {
 *     "userId": "user_1234567890abcdef1234",
 *     "timestamp": "2025-04-20T14:30:45Z"
 *   }
 * }
 *
 * Basic permission allowing a Guest user to access a chat via secret link
 * until that link expires.
 *  {
 *    "id": "permission_a1b2c3d4e5f6g7h8i9j0",
 *    "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_CHAT",
 *    "accessType": "ACCESS_TYPE_READ",
 *    "realmType": "REALM_TYPE_PUBLIC_SECRET",
 *    "created": {
 *      "userId": "user_1234567890abcdef1234",
 *      "timestamp": "2025-04-20T14:30:45Z"
 *    },
 *    "modified": {
 *      "userId": "user_1234567890abcdef1234",
 *      "timestamp": "2025-04-20T14:30:45Z"
 *    },
 *    "conditions": [
 *      {
 *        "resourceAttribute": {
 *          "logicalOperator": "LOGICAL_OPERATOR_AND_UNSPECIFIED",
 *          "attributes": [
 *            {
 *              "key": "secret_link_id",
 *              "stringValue": "link_j9k8l7m6n5o4p3q2r1s0",
 *              "operator": "OPERATOR_EQUALS"
 *            },
 *            {
 *              "key": "expiration_date",
 *              "stringValue": "2026-06-01T00:00:00Z",
 *              "operator": "OPERATOR_LESS_THAN"
 *            }
 *          ]
 *        }
 *      }
 *    ]
 *  }
 *
 * Permission with data classification condition:
 * {
 *   "id": "permission_b2c3d4e5f6g7h8i9j0k1",
 *   "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_CHAT",
 *   "accessType": "ACCESS_TYPE_SHARE",
 *   "realmType": "REALM_TYPE_OWN",
 *   "conditions": [
 *     {
 *       "dataClassification": {
 *         "maxClassification": "DATA_CLASSIFICATION_TYPE_PUBLIC"
 *       }
 *     }
 *   ]
 * }
 *
 * Permission with resource attribute condition:
 * {
 *   "id": "permission_c3d4e5f6g7h8i9j0k1l2",
 *   "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_ASSET",
 *   "accessType": "ACCESS_TYPE_READ",
 *   "realmType": "REALM_TYPE_ORGANIZATION",
 *   "conditions": [
 *     {
 *       "resourceAttribute": {
 *         "logicalOperator": "LOGICAL_OPERATOR_OR",
 *         "attributes": [
 *           {
 *             "key": "label",
 *             "stringValue": "label_c3d4e5f6g7h8i9j0k1l2",
 *             "operator": "OPERATOR_IN"
 *           },
 *           {
 *             "key": "label",
 *             "stringValue": "label_z4d4e6g6g7h8i9j0z9z9",
 *             "operator": "OPERATOR_IN"
 *           }
 *         ]
 *       }
 *     }
 *   ]
 * }
 *
 * Permission assigned to a Concept with confidence score condition:
 * {
 *   "id": "permission_d4e5f6g7h8i9j0k1l2m3",
 *   "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_CONCEPT",
 *   "accessType": "ACCESS_TYPE_UPDATE",
 *   "realmType": "REALM_TYPE_WORKSPACE",
 *   "conditions": [
 *     {
 *       "confidenceScore": {
 *         "minConfidence": 0.85,
 *         "feature": "concept_detection"
 *       }
 *     }
 *   ]
 * }
 *
 * Permission implementing:
 * - A confidence score condition
 * - That knowledge was approved by a moderator to be used to update concepts.
 * - That knowledge is classified as internal or public.
 * {
 *   "id": "permission_f6g7h8i9j0k1l2m3n4o5",
 *   "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_CONCEPT",
 *   "accessType": "ACCESS_TYPE_MODERATE",
 *   "realmType": "REALM_TYPE_WORKSPACE",
 *   "conditions": [
 *     {
 *       "confidenceScore": {
 *         "minConfidence": 0.95,
 *         "feature": "concept_detection"
 *       }
 *     },
 *     {
 *       "resourceAttribute": {
 *         "logicalOperator": "LOGICAL_OPERATOR_OR",
 *         "attributes": [
 *           {
 *             "key": "moderation_status",
 *             "stringValue": "approved",
 *             "operator": "OPERATOR_EQUALS"
 *           }
 *         ]
 *       }
 *     },
 *     {
 *       "dataClassification": {
 *         "maxClassification": "DATA_CLASSIFICATION_TYPE_INTERNAL"
 *       }
 *     }
 *   ]
 * }
 *
 * Complex permission with multiple conditions:
 * {
 *   "id": "permission_e5f6g7h8i9j0k1l2m3n4",
 *   "resourceType": "AUTHZ_AUTHZ_RESOURCE_TYPE_ARTIFACT",
 *   "accessType": "ACCESS_TYPE_SHARE",
 *   "realmType": "REALM_TYPE_WORKSPACE",
 *   "conditions": [
 *     {
 *       "dataClassification": {
 *         "maxClassification": "DATA_CLASSIFICATION_TYPE_INTERNAL"
 *       }
 *     },
 *     {
 *       "resourceAttribute": {
 *         "logicalOperator": "LOGICAL_OPERATOR_AND_UNSPECIFIED",
 *         "attributes": [
 *           {
 *             "key": "label",
 *             "stringValue": "label_e5f6g7h8i9j0k1l2m3n4",
 *             "operator": "OPERATOR_IN"
 *           },
 *           {
 *             "key": "label",
 *             "stringValue": "label_e5f6g7h8i9j0k1l2m3n4",
 *             "operator": "OPERATOR_EQUALS"
 *           }
 *         ]
 *       }
 *     }
 *   ]
 * }
 *
 * @generated from message authz.v3.Permission
 */
export type Permission = Message<"authz.v3.Permission"> & {
  /**
   * Unique identifier for the permission.
   * Format: ^permission_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Resource type this permission applies to.
   *
   * @generated from field: authz.v3.AuthzResourceType resource_type = 2;
   */
  resourceType: AuthzResourceType;

  /**
   * Access type (e.g., create, delete)
   *
   * @generated from field: authz.v3.AccessType access_type = 3;
   */
  accessType: AccessType;

  /**
   * Realm type (e.g., all, own, public, accessible from my team)
   *
   * @generated from field: authz.v3.RealmType realm_type = 4;
   */
  realmType: RealmType;

  /**
   * Attribution information for the user who created this permission.
   * Tracks creation metadata such as the timestamp and user details.
   *
   * @generated from field: common.v3.UserAttribution created = 6;
   */
  created?: UserAttribution;

  /**
   * Attribution information for the user who last modified this permission.
   * Tracks modification metadata such as the timestamp and user details.
   *
   * @generated from field: common.v3.UserAttribution modified = 7;
   */
  modified?: UserAttribution;

  /**
   * Conditions that must be satisfied for the permission to be granted.
   * If multiple conditions are specified, ALL must be met (logical AND).
   *
   * @generated from field: repeated authz.v3.Condition conditions = 8;
   */
  conditions: Condition[];
};

/**
 * Describes the message authz.v3.Permission.
 * Use `create(PermissionSchema)` to create a new message.
 */
export const PermissionSchema: GenMessage<Permission> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 0);

/**
 * ResourceAttributeCondition constrains access based on attributes
 * of the resource. This allows for fine-grained control based on resource
 * metadata or properties.
 *
 * For example, a condition might only grant access to assets with a specific
 * label or content-type.
 *
 * @generated from message authz.v3.ResourceAttributeCondition
 */
export type ResourceAttributeCondition = Message<"authz.v3.ResourceAttributeCondition"> & {
  /**
   * Set the logical operator (AND/OR) for combining attributes
   *
   * @generated from field: authz.v3.ResourceAttributeCondition.LogicalOperator logical_operator = 1;
   */
  logicalOperator: ResourceAttributeCondition_LogicalOperator;

  /**
   * Attributes to check using the specified logical operator
   *
   * @generated from field: repeated authz.v3.ResourceAttributeKeyPair attributes = 2;
   */
  attributes: ResourceAttributeKeyPair[];
};

/**
 * Describes the message authz.v3.ResourceAttributeCondition.
 * Use `create(ResourceAttributeConditionSchema)` to create a new message.
 */
export const ResourceAttributeConditionSchema: GenMessage<ResourceAttributeCondition> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 1);

/**
 * Logical operator to apply between attributes
 *
 * @generated from enum authz.v3.ResourceAttributeCondition.LogicalOperator
 */
export enum ResourceAttributeCondition_LogicalOperator {
  /**
   * Default - all attributes must match
   *
   * @generated from enum value: LOGICAL_OPERATOR_AND_UNSPECIFIED = 0;
   */
  AND_UNSPECIFIED = 0,

  /**
   * Any attribute can match
   *
   * @generated from enum value: LOGICAL_OPERATOR_OR = 1;
   */
  OR = 1,
}

/**
 * Describes the enum authz.v3.ResourceAttributeCondition.LogicalOperator.
 */
export const ResourceAttributeCondition_LogicalOperatorSchema: GenEnum<ResourceAttributeCondition_LogicalOperator> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 1, 0);

/**
 * Attribute represents a key-value pair with comparison operator
 *
 * @generated from message authz.v3.ResourceAttributeKeyPair
 */
export type ResourceAttributeKeyPair = Message<"authz.v3.ResourceAttributeKeyPair"> & {
  /**
   * Name of the attribute to check
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Value to compare against
   *
   * @generated from oneof authz.v3.ResourceAttributeKeyPair.value
   */
  value: {
    /**
     * @generated from field: string string_value = 2;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int64 int_value = 3;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * @generated from field: bool bool_value = 4;
     */
    value: boolean;
    case: "boolValue";
  } | {
    /**
     * @generated from field: double double_value = 5;
     */
    value: number;
    case: "doubleValue";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: authz.v3.ResourceAttributeKeyPair.Operator operator = 6;
   */
  operator: ResourceAttributeKeyPair_Operator;
};

/**
 * Describes the message authz.v3.ResourceAttributeKeyPair.
 * Use `create(ResourceAttributeKeyPairSchema)` to create a new message.
 */
export const ResourceAttributeKeyPairSchema: GenMessage<ResourceAttributeKeyPair> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 2);

/**
 * Comparison operator
 *
 * @generated from enum authz.v3.ResourceAttributeKeyPair.Operator
 */
export enum ResourceAttributeKeyPair_Operator {
  /**
   * @generated from enum value: OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OPERATOR_EQUALS = 1;
   */
  EQUALS = 1,

  /**
   * @generated from enum value: OPERATOR_NOT_EQUALS = 2;
   */
  NOT_EQUALS = 2,

  /**
   * @generated from enum value: OPERATOR_CONTAINS = 3;
   */
  CONTAINS = 3,

  /**
   * @generated from enum value: OPERATOR_GREATER_THAN = 4;
   */
  GREATER_THAN = 4,

  /**
   * @generated from enum value: OPERATOR_LESS_THAN = 5;
   */
  LESS_THAN = 5,

  /**
   * @generated from enum value: OPERATOR_IN = 6;
   */
  IN = 6,

  /**
   * @generated from enum value: OPERATOR_NOT_IN = 7;
   */
  NOT_IN = 7,
}

/**
 * Describes the enum authz.v3.ResourceAttributeKeyPair.Operator.
 */
export const ResourceAttributeKeyPair_OperatorSchema: GenEnum<ResourceAttributeKeyPair_Operator> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 2, 0);

/**
 * DataSecurityClassificationCondition constrains access based on resource
 * classification level.
 *
 * @generated from message authz.v3.DataSecurityClassificationCondition
 */
export type DataSecurityClassificationCondition = Message<"authz.v3.DataSecurityClassificationCondition"> & {
  /**
   * The maximum classification level a user must be cleared for
   *
   * @generated from field: authz.v3.DataSecurityClassificationType max_classification = 1;
   */
  maxClassification: DataSecurityClassificationType;
};

/**
 * Describes the message authz.v3.DataSecurityClassificationCondition.
 * Use `create(DataSecurityClassificationConditionSchema)` to create a new message.
 */
export const DataSecurityClassificationConditionSchema: GenMessage<DataSecurityClassificationCondition> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 3);

/**
 * ConfidenceScoreCondition constrains access based on confidence threshold.
 * This is useful for ML-driven features where actions might depend on
 * the confidence level of predictions or detections.
 *
 * For example, automatic categorization might require a high confidence score,
 * while user-assisted categorization could work with a lower threshold.
 *
 * @generated from message authz.v3.ConfidenceScoreCondition
 */
export type ConfidenceScoreCondition = Message<"authz.v3.ConfidenceScoreCondition"> & {
  /**
   * Minimum confidence score required (0.0 to 1.0)
   *
   * @generated from field: double min_confidence = 1;
   */
  minConfidence: number;

  /**
   * Optional maximum confidence (for conditions requiring medium confidence)
   *
   * @generated from field: optional double max_confidence = 2;
   */
  maxConfidence: number;

  /**
   * Optional feature this confidence applies to (e.g., "prediction", "detection")
   *
   * @generated from field: optional authz.v3.ConfidenceFeature feature = 3;
   */
  feature: ConfidenceFeature;
};

/**
 * Describes the message authz.v3.ConfidenceScoreCondition.
 * Use `create(ConfidenceScoreConditionSchema)` to create a new message.
 */
export const ConfidenceScoreConditionSchema: GenMessage<ConfidenceScoreCondition> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 4);

/**
 * Condition is a wrapper for various conditional checks that can be applied to
 * permissions. Conditions refine when a permission is granted, adding
 * contextual constraints beyond the basic who/what/where defined by the
 * permission itself.
 *
 * Conditions are evaluated at runtime and all specified conditions must be
 * satisfied for the permission to be granted.
 *
 * @generated from message authz.v3.Condition
 */
export type Condition = Message<"authz.v3.Condition"> & {
  /**
   * @generated from oneof authz.v3.Condition.condition_type
   */
  conditionType: {
    /**
     * @generated from field: authz.v3.DataSecurityClassificationCondition data_security_classification = 1;
     */
    value: DataSecurityClassificationCondition;
    case: "dataSecurityClassification";
  } | {
    /**
     * @generated from field: authz.v3.ResourceAttributeCondition resource_attribute = 2;
     */
    value: ResourceAttributeCondition;
    case: "resourceAttribute";
  } | {
    /**
     * @generated from field: authz.v3.ConfidenceScoreCondition confidence_score = 3;
     */
    value: ConfidenceScoreCondition;
    case: "confidenceScore";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message authz.v3.Condition.
 * Use `create(ConditionSchema)` to create a new message.
 */
export const ConditionSchema: GenMessage<Condition> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 5);

/**
 * Request to check if a user has specific permissions
 *
 * @generated from message authz.v3.CheckPermissionRequest
 */
export type CheckPermissionRequest = Message<"authz.v3.CheckPermissionRequest"> & {
  /**
   * ID of the user to check permissions for
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * The resource being accessed
   *
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * Type of resource being accessed
   *
   * @generated from field: authz.v3.AuthzResourceType resource_type = 3;
   */
  resourceType: AuthzResourceType;

  /**
   * The action being attempted
   *
   * @generated from field: authz.v3.AccessType access_type = 4;
   */
  accessType: AccessType;
};

/**
 * Describes the message authz.v3.CheckPermissionRequest.
 * Use `create(CheckPermissionRequestSchema)` to create a new message.
 */
export const CheckPermissionRequestSchema: GenMessage<CheckPermissionRequest> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 6);

/**
 * Response indicating whether the permission check passed
 *
 * @generated from message authz.v3.CheckPermissionResponse
 */
export type CheckPermissionResponse = Message<"authz.v3.CheckPermissionResponse"> & {
  /**
   * Whether the user has the requested permission
   *
   * @generated from field: bool has_permission = 1;
   */
  hasPermission: boolean;
};

/**
 * Describes the message authz.v3.CheckPermissionResponse.
 * Use `create(CheckPermissionResponseSchema)` to create a new message.
 */
export const CheckPermissionResponseSchema: GenMessage<CheckPermissionResponse> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 7);

/**
 * Request to grant one or more permissions
 *
 * @generated from message authz.v3.GrantPermissionRequest
 */
export type GrantPermissionRequest = Message<"authz.v3.GrantPermissionRequest"> & {
  /**
   * ID of the user to grant permissions to
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * List of permissions to grant
   *
   * @generated from field: repeated authz.v3.Permission permissions = 2;
   */
  permissions: Permission[];
};

/**
 * Describes the message authz.v3.GrantPermissionRequest.
 * Use `create(GrantPermissionRequestSchema)` to create a new message.
 */
export const GrantPermissionRequestSchema: GenMessage<GrantPermissionRequest> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 8);

/**
 * Response to permission grant request
 *
 * @generated from message authz.v3.GrantPermissionResponse
 */
export type GrantPermissionResponse = Message<"authz.v3.GrantPermissionResponse"> & {
  /**
   * IDs of the successfully granted permissions
   *
   * @generated from field: repeated string granted_permission_ids = 1;
   */
  grantedPermissionIds: string[];
};

/**
 * Describes the message authz.v3.GrantPermissionResponse.
 * Use `create(GrantPermissionResponseSchema)` to create a new message.
 */
export const GrantPermissionResponseSchema: GenMessage<GrantPermissionResponse> = /*@__PURE__*/
  messageDesc(file_authz_v3_authz, 9);

/**
 * ResourceType enumerates all resource types in the system which can be
 * governed by permissions and access controls.
 *
 * Resources are objects that can be created, accessed, and manipulated within
 * the platform. Each resource type can have different permission requirements
 * and access control rules.
 *
 * Example usage:
 *   permission.resource_type = AuthzResourceType.AUTHZ_RESOURCE_TYPE_PROJECT;
 *
 * @generated from enum authz.v3.AuthzResourceType
 */
export enum AuthzResourceType {
  /**
   * Default unspecified value. Should not be used directly.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Represents a user managing their own account settings and profile.
   * Used for self-service operations like updating personal information.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_SELF = 1;
   */
  SELF = 1,

  /**
   * Represents user accounts managed by administrators.
   * Used for user management operations like editing accounts
   * or assigning roles directly.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_USER = 2;
   */
  USER = 2,

  /**
   * Represents a project container for organizing related resources.
   * Projects can contain chats, concepts, artifacts, and other resources.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_PROJECT = 3;
   */
  PROJECT = 3,

  /**
   * Represents an isolated environment and data boundary.
   * Workspaces provide boundaries for collaboration and access control.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_WORKSPACE = 4;
   */
  WORKSPACE = 4,

  /**
   * Represents a group of users with shared permissions.
   * Teams enable collaborative work and simplified permission management.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_TEAM = 5;
   */
  TEAM = 5,

  /**
   * Represents chat conversations within the platform.
   * Chats can be shared, exported, and contain messages with attachments.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_CHAT = 6;
   */
  CHAT = 6,

  /**
   * Represents knowledge associated with chats and are unavailable outside
   * of a chat container.
   *
   * Attachments may become assets.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_ATTACHMENT = 7;
   */
  ATTACHMENT = 7,

  /**
   * Represents reusable knowledge resources used across the platform.
   * Assets may include any ingress data including files or records from
   * integrated third-party systems.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_ASSET = 8;
   */
  ASSET = 8,

  /**
   * Represents published and versioned outputs from system interactions.
   * Artifacts capture results from workflows and analyses for future reference.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_ARTIFACT = 9;
   */
  ARTIFACT = 9,

  /**
   * Represents unified ideas formed from the knowledge base.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_CONCEPT = 10;
   */
  CONCEPT = 10,

  /**
   * Represents automated workflows and operations.
   * Actions can be scheduled, triggered, or manually executed.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_ACTION = 11;
   */
  ACTION = 11,

  /**
   * Represents notification settings for resource changes or events.
   * Subscriptions allow users to stay informed about relevant updates.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_SUBSCRIPTION = 12;
   */
  SUBSCRIPTION = 12,

  /**
   * Represents collections of reusable prompts and templates.
   * Prompt libraries enable consistent interactions and shared best practices.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_PROMPT_LIBRARY = 13;
   */
  PROMPT_LIBRARY = 13,

  /**
   * Represents a top-level multi-organization container.
   * Tenants provide isolation between different customer environments.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_TENANT = 14;
   */
  TENANT = 14,

  /**
   * Represents a business entity with users, teams, and resources.
   * Organizations define administrative boundaries and billing units.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_ORGANIZATION = 15;
   */
  ORGANIZATION = 15,

  /**
   * Collections (labels) provide organizational tags for resources.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_COLLECTION = 16;
   */
  COLLECTION = 16,

  /**
   * Views provide saved filter configurations for finding resources.
   *
   * @generated from enum value: AUTHZ_RESOURCE_TYPE_VIEW = 17;
   */
  VIEW = 17,
}

/**
 * Describes the enum authz.v3.AuthzResourceType.
 */
export const AuthzResourceTypeSchema: GenEnum<AuthzResourceType> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 0);

/**
 * AccessType enumerates all possible operations (actions) that can be
 * performed on resources. These operations form the basis of permission checks
 * throughout the system.
 *
 * AccessType values define the "verb" in permission statements - they specify
 * what action is being performed on a resource.
 *
 * Example usage in permission check:
 *   if !canAccess(user, AccessType_READ, project) {
 *     return status.Error(codes.PermissionDenied, "not authorized to view this project")
 *   }
 *
 * @generated from enum authz.v3.AccessType
 */
export enum AccessType {
  /**
   * Default unspecified value. Should not be used directly.
   *
   * @generated from enum value: ACCESS_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Creates a new instance of a resource.
   *
   * @generated from enum value: ACCESS_TYPE_CREATE = 1;
   */
  CREATE = 1,

  /**
   * Retrieves and views an existing resource.
   *
   * @generated from enum value: ACCESS_TYPE_READ = 2;
   */
  READ = 2,

  /**
   * Modifies an existing resource's properties or content.
   *
   * @generated from enum value: ACCESS_TYPE_UPDATE = 3;
   */
  UPDATE = 3,

  /**
   * Permanently removes a resource from the system.
   *
   * @generated from enum value: ACCESS_TYPE_DELETE = 4;
   */
  DELETE = 4,

  /**
   * Performs administrative operations on resources.
   * Includes configuration changes and advanced settings.
   *
   * @generated from enum value: ACCESS_TYPE_MANAGE = 5;
   */
  MANAGE = 5,

  /**
   * Reviews and approves/rejects content or changes.
   * Used in workflows requiring quality control or moderation.
   *
   * @generated from enum value: ACCESS_TYPE_APPROVE = 6;
   */
  APPROVE = 6,

  /**
   * Makes content publicly accessible or reverts to private.
   * Controls visibility of resources to wider audiences.
   *
   * @generated from enum value: ACCESS_TYPE_PUBLISH = 7;
   */
  PUBLISH = 7,

  /**
   * Extends access to resources to additional users or groups.
   * Enables collaboration while maintaining access controls.
   *
   * @generated from enum value: ACCESS_TYPE_SHARE = 8;
   */
  SHARE = 8,

  /**
   * Reviews and manages content for compliance and quality.
   * Includes flagging, hiding, or modifying inappropriate content.
   *
   * @generated from enum value: ACCESS_TYPE_MODERATE = 9;
   */
  MODERATE = 9,

  /**
   * Runs a specific operation, workflow, or action.
   * Initiates processes that may alter resources or generate results.
   *
   * @generated from enum value: ACCESS_TYPE_EXECUTE = 10;
   */
  EXECUTE = 10,

  /**
   * Extracts data from the system in various formats.
   * Enables data portability and external processing.
   *
   * @generated from enum value: ACCESS_TYPE_EXPORT = 11;
   */
  EXPORT = 11,

  /**
   * Observes system activity and performance metrics.
   * Provides visibility into resource usage and operations.
   *
   * @generated from enum value: ACCESS_TYPE_MONITOR = 12;
   */
  MONITOR = 12,

  /**
   * Reviews historical activity logs for compliance or analysis.
   * Provides accountability and tracking of user actions.
   *
   * @generated from enum value: ACCESS_TYPE_AUDIT = 13;
   */
  AUDIT = 13,

  /**
   * Sends invitations to new or existing users.
   * Controls onboarding and expansion of system access.
   *
   * @generated from enum value: ACCESS_TYPE_INVITE = 15;
   */
  INVITE = 15,

  /**
   * Registers for notifications about resource changes.
   * Enables users to stay informed about relevant updates.
   *
   * @generated from enum value: ACCESS_TYPE_SUBSCRIBE = 16;
   */
  SUBSCRIBE = 16,

  /**
   * Represents financial transactions or operations. Provides access to
   * billing information, the ability to setup cost centers, establish
   * payment methods, or set budgets and spending limits.
   *
   * @generated from enum value: ACCESS_TYPE_FINANCIAL = 17;
   */
  FINANCIAL = 17,
}

/**
 * Describes the enum authz.v3.AccessType.
 */
export const AccessTypeSchema: GenEnum<AccessType> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 1);

/**
 * RealmType defines the scope or boundary within which a permission applies.
 * It answers the question "over what group of resources does
 * this permission apply?"
 *
 * For example, REALM_TYPE_ORGANIZATION means the permission applies to all
 * resources within the organization, while REALM_TYPE_OWN means it only applies
 * to resources the user has created themselves.
 *
 * @generated from enum authz.v3.RealmType
 */
export enum RealmType {
  /**
   * @generated from enum value: REALM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Engineering/Operations Only.
   * The broadest permission possible, applying to all resources
   * of the specified type regardless of ownership or organization boundaries.
   *
   * This is only allowed in controlled operational tooling.
   *
   * @generated from enum value: REALM_TYPE_ALL = 1;
   */
  ALL = 1,

  /**
   * Resources owned by the user.
   * Example: A user can edit their own profile but not others'.
   *
   * @generated from enum value: REALM_TYPE_OWN = 2;
   */
  OWN = 2,

  /**
   * Resources that have been made available to the public via a secret link.
   * Crawlers are asked not to index this content.
   *
   * @generated from enum value: REALM_TYPE_PUBLIC_SECRET = 3;
   */
  PUBLIC_SECRET = 3,

  /**
   * Resources that are publicly available and indexed by search engines.
   * Crawlers are encouraged to index this content.
   *
   * @generated from enum value: REALM_TYPE_PUBLIC_INDEXED = 4;
   */
  PUBLIC_INDEXED = 4,

  /**
   * Resources where a private link has been generated for sharing with
   * users who have the link and access to the organization.
   *
   * @generated from enum value: REALM_TYPE_PRIVATE_SECRET = 5;
   */
  PRIVATE_SECRET = 5,

  /**
   * Resources contained within a project. A standard realm to grant access
   * to a user.
   *
   * @generated from enum value: REALM_TYPE_PROJECT = 6;
   */
  PROJECT = 6,

  /**
   * All resources available within a workspace. A rather broad permission.
   *
   * @generated from enum value: REALM_TYPE_WORKSPACE = 7;
   */
  WORKSPACE = 7,

  /**
   * All resources available to the team.
   *
   * @generated from enum value: REALM_TYPE_TEAM = 8;
   */
  TEAM = 8,

  /**
   * Resources within an organization, any of it's workspaces, projects, etc.
   * A very broad permission.
   *
   * @generated from enum value: REALM_TYPE_ORGANIZATION = 9;
   */
  ORGANIZATION = 9,

  /**
   * Resources in a tenant, any of it's organizations, workspaces,
   * projects, etc. The broadest permission assignable to a user.
   *
   * @generated from enum value: REALM_TYPE_TENANT = 10;
   */
  TENANT = 10,
}

/**
 * Describes the enum authz.v3.RealmType.
 */
export const RealmTypeSchema: GenEnum<RealmType> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 2);

/**
 * DataSecurityClassificationType constrains access based on resource
 * classification level. This ensures users can only access resources with
 * classification levels they are cleared to access.
 *
 * For example, a user might be granted permission to access INTERNAL documents
 * but not RESTRICTED ones.
 *
 * Data classification levels are also useful when permissions are assigned
 * to Actions or Concepts. For example, a Concept might have a permission
 * that only allows INTERNAL data to be used when discovering and applying
 * updates preventing confidential or restricted data from being used to
 * update the concept.
 *
 * @generated from enum authz.v3.DataSecurityClassificationType
 */
export enum DataSecurityClassificationType {
  /**
   * Default unspecified value. Should not be used directly.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Information intended for public consumption.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * Information for general internal use.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_INTERNAL = 2;
   */
  INTERNAL = 2,

  /**
   * Information requiring controlled access.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_CONFIDENTIAL = 3;
   */
  CONFIDENTIAL = 3,

  /**
   * Highly sensitive information with strict access limitations.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_RESTRICTED = 4;
   */
  RESTRICTED = 4,

  /**
   * Information with the highest level of sensitivity and security.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_SECRET = 5;
   */
  SECRET = 5,

  /**
   * Information classified as top secret, requiring the highest level of
   * security clearance and access control.
   *
   * @generated from enum value: DATA_SECURITY_CLASSIFICATION_TYPE_TOP_SECRET = 6;
   */
  TOP_SECRET = 6,
}

/**
 * Describes the enum authz.v3.DataSecurityClassificationType.
 */
export const DataSecurityClassificationTypeSchema: GenEnum<DataSecurityClassificationType> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 3);

/**
 * ConfidenceFeature defines categories for which confidence scores can be
 * calculated in the system.
 *
 * Each feature represents a distinct type of operation where measuring
 * the system's confidence in its output is valuable for determining
 * reliability and making downstream decisions.
 *
 * @generated from enum authz.v3.ConfidenceFeature
 */
export enum ConfidenceFeature {
  /**
   * Default unspecified value. Should not be used directly.
   *
   * @generated from enum value: CONFIDENCE_FEATURE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Confidence score for predictions made by the system.
   *
   * @generated from enum value: CONFIDENCE_FEATURE_PREDICTION = 1;
   */
  PREDICTION = 1,

  /**
   * Confidence score for detections made by the system.
   *
   * @generated from enum value: CONFIDENCE_FEATURE_CONCEPT_DETECTION = 2;
   */
  CONCEPT_DETECTION = 2,
}

/**
 * Describes the enum authz.v3.ConfidenceFeature.
 */
export const ConfidenceFeatureSchema: GenEnum<ConfidenceFeature> = /*@__PURE__*/
  enumDesc(file_authz_v3_authz, 4);

/**
 * AuthzService provides methods for managing permissions and access control.
 *
 * @generated from service authz.v3.AuthzService
 */
export const AuthzService: GenService<{
  /**
   * CheckPermission verifies if a user has permission to perform an action on a resource
   *
   * @generated from rpc authz.v3.AuthzService.CheckPermission
   */
  checkPermission: {
    methodKind: "unary";
    input: typeof CheckPermissionRequestSchema;
    output: typeof CheckPermissionResponseSchema;
  },
  /**
   * GrantPermission assigns one or more permissions to a user
   *
   * @generated from rpc authz.v3.AuthzService.GrantPermission
   */
  grantPermission: {
    methodKind: "unary";
    input: typeof GrantPermissionRequestSchema;
    output: typeof GrantPermissionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_authz_v3_authz, 0);

